module.exports = __webpack_public_path__ + "static/media/leonardoCorrales.3ead4e44.jpg";